<footer>
    <ng-content />
    <nav>
        <ul>
            @for (item of footerItems; track item) {
                <li>
                    <a [routerLink]="item.link">{{ item.label | translate }}</a>
                </li>
            }
        </ul>
        <div hlmSeparator orientation="vertical" class="tw-h-4"></div>
        <a
            href="https://feedback.siteboard.io/de/changelog"
            target="_blank"
            [title]="'UI_COMPONENTS.FOOTER.VERSION.TITLE' | translate"
        >
            {{ 'UI_COMPONENTS.FOOTER.VERSION.LABEL' | translate:{version: packageVersion} }}
            <sona-icon name="arrow-square-out" size="tiny" class="tw-ml-1" />
        </a>
    </nav>
</footer>
